import { render, staticRenderFns } from "./DashboardHeadCard.vue?vue&type=template&id=5e01f6d8&scoped=true&"
import script from "./DashboardHeadCard.vue?vue&type=script&lang=js&"
export * from "./DashboardHeadCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeadCard.vue?vue&type=style&index=0&id=5e01f6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01f6d8",
  null
  
)

export default component.exports